import React, { useState } from "react";
import { faviconUrl, isPlaceholderIcon } from "Pages/Dashboard/Accounts/accountLogo";
import { initials } from "./signalMeta";

/** A company's own icon from the icon service, else its first letter. */
export const AccountLogo = ({ domain, name }) => {
  const [failed, setFailed] = useState(false);
  const src = faviconUrl(domain);
  return (
    <span className="sg-logo" aria-hidden="true">
      {src && !failed ? (
        <img src={src} alt="" loading="lazy" onError={() => setFailed(true)} onLoad={e => isPlaceholderIcon(e.target) && setFailed(true)} />
      ) : (
        initials(name).slice(0, 1)
      )}
    </span>
  );
};
